// extracted by mini-css-extract-plugin
module.exports = {"GroupWrapper":"AssessorGroupCollapse__GroupWrapper___vHMJ-","AddButtonWrapper":"AssessorGroupCollapse__AddButtonWrapper___2rPSm","Button":"AssessorGroupCollapse__Button___1JR-F"};